import React from "react";
import Box from "../../components/base/box";

import { white } from "../../components/base/colors";
import ExpandButton from "../../components/expand-button";

const FAQItem = ({
  question,
  answer,
  isExpanded,
  setIsExpanded,
  setIsntExpanded,
}) => (
  <div className="faq" id="js-faq">
    <Box
      as="button"
      cursor="pointer"
      border="none"
      width="100%"
      className="faq-header"
      onClick={isExpanded ? setIsntExpanded : setIsExpanded}
    >
      <h2 className="faq-question">{question}</h2>
      <ExpandButton as="div" color={white} isExpanded={isExpanded} />
    </Box>
    {isExpanded && (
      <div
        className="faq-answer"
        dangerouslySetInnerHTML={{ __html: answer }}
      />
    )}
  </div>
);

export default FAQItem;
